<!--
  ZDSL doplňková mapová nástrojová nabídka 
-->
<template>

  <div class="d-flex flex-row">

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="MapPnlGrdItem elevation-5" width="40" min-width="40" min-height="40" color="info" v-bind="attrs"
          v-on="on" @click="MapLayerLegendStaticSet()">
          <v-icon>mdi-map-legend</v-icon>
        </v-btn>
      </template>
      <span class="">Legenda</span>
    </v-tooltip>

    <v-card width="408" color="transparent" flat>
      <v-overflow-btn class="MapPnlGrdItem elevation-5 u_v-autocomplete " :items="ZdslList" v-model="VybZdsl"
        item-text="Name" return-object dense hide-details="true" background-color="info" height="40">
        <template v-slot:item="{ item, attrs, on }">
          <v-list-item v-bind="attrs" v-on="on" two-line>
            <v-list-item-content style="max-width:600px ;">
              <v-list-item-title v-text="item.Name"></v-list-item-title>
              <v-list-item-subtitle class="text-wrap" v-text="item.Popis" />
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-overflow-btn>
    </v-card>

    <v-card width="120" color="transparent" flat>
      <v-overflow-btn class="MapPnlGrdItem elevation-5 u_v-autocomplete " :items="VybZdsl.Rocnik" item-text="rok"
        v-model="VybRok" return-object dense hide-details="true" height="40" background-color="info">
      </v-overflow-btn>
    </v-card>

    <template v-if="VybRokObdobi.length > 0">
      <v-card width="160" color="transparent" flat>
        <v-overflow-btn class="MapPnlGrdItem elevation-5 u_v-autocomplete " :items="VybRokObdobi" item-text="doba"
          v-model="VybDoba" return-object dense hide-details="true" height="40" background-color="info">
        </v-overflow-btn>
      </v-card>
    </template>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="MapPnlGrdItem elevation-5" width="40" min-width="40" min-height="40" color="info" v-bind="attrs"
          v-on="on" @click="VybComp = 'DsZdslInfo'">
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
      </template>
      <span class="">Informace</span>
    </v-tooltip>





  </div>
</template>

<script>
import AppZdsl from "../../../assets/MapOt_Zdsl.json";


export default {

  components: {
    //Teleport: () => import("vue2-teleport")
  },


  props: {
    // Adresa na Assets
    AssetsUrl: null,
    // Mapová služba
    ServiceMap: null,
    // Mapa (Luciad)
    MAP: Object,
    // Měřítko vztažené k rovníku
    MapScale: null,
    // Mapové vrstvy
    MapLegendLayers: null,
    // Viditelnost legendy
    MapLayerLegend_view: null,

    // Seznam  komponent
    CompList: { type: Array },

  },

  data() {
    return {
      // Jestli je nástroj inicializován
      IsInit: false,
      // id vrstvy Zdsl
      ZdslLayerId: "Uhul_zdsl",

      // Seznam vrstev
      ZdslList: [],
      // Vybraná vrstva
      VybZdsl: {
        "id": "",
        "Name": "",
        "Popis": "",
        "Rocnik": [],
        "Legenda": [],
      },
      // Vybraný rok
      VybRok: null,
      // Vybraná doba
      VybDoba: null,
      // Vybraný kód - první vrstva
      VybKod: 'FII_2017',

      // Seznam načtených legend
      ZdslStaticLegends: {},

    };
  },



  computed: {
    // Vrstva zdsl
    MapLayer_Uhul_zdsl: function () {
      return this.MapLegendLayers.find((item) => item.id == this.ZdslLayerId);
    },

    // seznam období vybraného roku
    VybRokObdobi: function () {
      if (this.VybRok != null) {
        if (typeof this.VybRok['obdobi'] !== 'undefined') {
          return this.VybRok.obdobi
        } else {
          return []
        }
      }
      else {
        return []
      }
    },

    // Změna vybrané komponenty podle jména
    VybComp: {
      get() {
        return this.$store.getters.GET_sVybComp;
      },
      set(newValue) {
        this.$store.commit("SET_sVybComp", {
          CompName: newValue,
          SlotName: this.CompList.find((item) => item.name == newValue).slot,
        });
      },
    },



  },

  watch: {
    // Změna druhu mapy
    VybZdsl: function (value) {
      // console.log("zMĚNA - VybZdsl");
      // console.log(value);
      this.VybRok = value.Rocnik[0];

      // Změna legendy, když je zobrazena a došlo ke změně typu
      if (this.MapLayerLegend_view) {
        this.MapLayerLegendStaticSet();
      }

    },

    // Změna roku
    VybRok: function (value) {
      // console.log("zMĚNA - VybRok");
      // console.log(value);

      if (this.VybRokObdobi.length > 0) {
        this.VybDoba = value.obdobi[0];
      } else {
        this.VybDoba = null;
        this.VybKod = value.kod
      }

    },

    // Změna doby
    VybDoba: function (value) {
      // console.log("zMĚNA - VybDoba");
      // console.log(value);
      if (value != null) {
        this.VybKod = value.kod
      }
    },

    // Změna kodu / mapy
    VybKod: function (value, oldValue) {
      if (this.IsInit) {
        // console.log("zMĚNA - VybKod");
        // console.log(value);
        // console.log(oldValue);

        var vModel = this.MapLayer_Uhul_zdsl.layer.model;
        vModel.baseURL = vModel.baseURL.replace(oldValue, value);
        this.MapLayer_Uhul_zdsl.label = this.VybZdsl.Name;
        if (this.VybDoba == null) {
          this.MapLayer_Uhul_zdsl.labelsub = this.VybRok.rok;
        } else {
          this.MapLayer_Uhul_zdsl.labelsub = this.VybDoba.doba;
        }

      }
    },


  },

  methods: {



    // Statická mapová legenda - proměnná pro vybranou vrstvu - volá se funkce v nadřazeném objektu
    MapLayerLegendStaticSet: function () {
      this.$emit('MapLayerLegendStaticSet', this.ZdslLayerId, this.VybZdsl.LegendaTitle, this.ZdslStaticLegends[this.VybZdsl.id]);
    },


    // Načtení statické legendy
    NactiStaticMapLegend: function (id, Jmeno) {
      this.ServiceMap.MapLegend(Jmeno)
        .then((response) => {
          if (response.data.Dokonceno) {
            this.ZdslStaticLegends[id] = response.data.Vypis;
          } else {
            return null;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    },





  },

  mounted() {
    // První spuštění nástroje
    //console.log("ZDSL start");

    // Základní nastavení - 
    this.ZdslList = AppZdsl.ZdslList;
    // Načtení první vrstvy ze seznamu
    this.VybZdsl = this.ZdslList[0];

    // // Objekt aktivován
    this.MAP.layerTree.whenReady().then(() => { this.IsInit = true; })

    // Načtení legend
    this.ZdslList.forEach((value) => {
      this.NactiStaticMapLegend(value.id, value.Legenda)
    });


  },
};
</script>